/**
 * What THIS project calls its discussions.
 *
 * "Discussions" is the Basecamp-era word; some clients think in Requests,
 * Tickets, or Updates (Jesse, 2026-08-25). The label lives in
 * `project.settings.discussionsLabel` and is set per project by an agency
 * admin — nothing else about discussions changes: routes, notifications and
 * the data model keep the one internal name.
 *
 * ONE helper so every surface renames together — a tab saying "Requests"
 * above a button saying "New discussion" is worse than either name.
 */
export interface DiscussionLabels {
  singular: string;
  plural: string;
}

export function discussionLabels(settings: unknown): DiscussionLabels {
  const raw =
    settings && typeof settings === 'object'
      ? ((settings as Record<string, unknown>).discussionsLabel as
          | { singular?: unknown; plural?: unknown }
          | undefined)
      : undefined;
  const singular =
    typeof raw?.singular === 'string' && raw.singular.trim() ? raw.singular.trim() : 'Discussion';
  const plural =
    typeof raw?.plural === 'string' && raw.plural.trim()
      ? raw.plural.trim()
      : singular === 'Discussion'
        ? 'Discussions'
        : `${singular}s`;
  return { singular, plural };
}
